import { Box } from "@mui/material";
import TextField from "@mui/material/TextField";
import { DateInformation, PersonDateType } from "@repo/server-api";
import { ContactExtended } from "@repo/server-api/types";
import { useTranslation } from "next-i18next";
import React, {
	forwardRef,
	useCallback,
	useEffect,
	useImperativeHandle,
	useMemo,
	useRef,
	useState,
} from "react";
// import * as Yup from "yup";

import { setContactValues } from "@repo/legacy/components/helper/Index";

import DateField from "../fields/DateField";

type Exposed = {
	validate: () => Promise<Record<string, boolean | object | string>>;
};

const OtherPersonSection = forwardRef(
	(
		props: Readonly<{
			contact: ContactExtended | null;
			setContact: (value: ContactExtended) => void;
			errors?: Record<string, boolean | object | string>;
			setErrors?: (value: Record<string, boolean | object | string>) => void;
		}>,
		ref: React.Ref<Exposed>,
	) => {
		const { t } = useTranslation();

		const info = useMemo<ContactExtended>(() => {
			return setContactValues(props.contact);
		}, [props.contact]);

		const [shortCodeLocal, setShortCodeLocal] = useState(info.shortCode ?? "");
		const [dateLocal, setDateLocal] = useState<string>("");

		const shortFocusedRef = useRef(false);

		useEffect(() => {
			if (!shortFocusedRef.current) setShortCodeLocal(info.shortCode ?? "");
		}, [info.shortCode]);

		useEffect(() => {
			const dateInfo = info.additionalInformation.find(
				(item): item is DateInformation =>
					(item as DateInformation).__typename === "DateInformation" &&
					(item as DateInformation).personDateType === PersonDateType.BirthDate,
			) as DateInformation | undefined;
			setDateLocal(dateInfo?.date ?? "");
		}, [info]);

		// const validationSchema = Yup.object().shape({});

		const validateFields = useCallback(async () => {
			const localErrors: Record<string, boolean | object | string> = {};

			return localErrors;
		}, [props]);

		useImperativeHandle(ref, () => ({
			validate: validateFields,
		}));

		const setInContact = (patch: Partial<ContactExtended>) => {
			if (!props.contact) return;
			props.setContact({ ...props.contact, ...patch } as ContactExtended);
		};

		return (
			<div>
				<Box sx={{ display: "flex", gap: "2%" }}>
					<TextField
						onChange={(event) => {
							const v = event.target.value ?? "";
							setShortCodeLocal(v);
							setInContact({ ...info, shortCode: v });
						}}
						onFocus={() => {
							shortFocusedRef.current = true;
						}}
						onBlur={() => {
							shortFocusedRef.current = false;
							setShortCodeLocal(setContactValues(props.contact).shortCode ?? "");
						}}
						value={shortCodeLocal}
						label={t("short-code")}
						variant="outlined"
						sx={{ width: "50%" }}
					/>
					<Box sx={{ width: "50%" }}>
						<DateField
							isLoaded={!!props.contact?.id}
							label={t("date-of-birth")}
							value={dateLocal as string}
							setValue={(newValue) => {
								setDateLocal(newValue);
								const dateInfo = info.additionalInformation.find(
									(item): item is DateInformation =>
										(item as DateInformation).__typename === "DateInformation" &&
										(item as DateInformation).personDateType === PersonDateType.BirthDate,
								) as DateInformation | undefined;
								setInContact({
									...info,
									additionalInformation: dateInfo
										? info.additionalInformation.map((item) => {
												if (
													(item as DateInformation).__typename === "DateInformation" &&
													(item as DateInformation).personDateType === PersonDateType.BirthDate
												) {
													return { ...item, date: newValue };
												} else {
													return item;
												}
											})
										: [
												...info.additionalInformation,
												{
													__typename: "DateInformation",
													personDateType: PersonDateType.BirthDate,
													date: newValue,
												} as DateInformation,
											],
								});
							}}
						/>
					</Box>
				</Box>
			</div>
		);
	},
);

OtherPersonSection.displayName = "OtherPersonSection";
export default OtherPersonSection;
